export const messages = {
    en: {
      myRepairDispatchManage: {
        queryCondition: 'Query Conditions',
        selectMaintenanceType: 'Select Maintenance Type',
        inputRepairName: 'Enter Reporter Name',
        inputRepairTel: 'Enter Reporter Phone',
        selectRepairType: 'Select Repair Type',
        selectRepairState: 'Select Repair State',
        inputRepairId: 'Enter Work Order ID',
        repairDispatch: 'Repair Dispatch',
        repairId: 'Work Order ID',
        location: 'Location',
        repairType: 'Repair Type',
        maintenanceType: 'Maintenance Type',
        repairPerson: 'Reporter',
        contact: 'Contact',
        appointmentTime: 'Appointment Time',
        state: 'Status',
        operation: 'Operation',
        detail: 'Detail',
        scheduledTask: 'Scheduled Task',
        paidService: 'Paid Service',
        freeService: 'Free Service',
        needMaterial: 'Need Material',
        noMaterial: 'No Material'
      },
          closeOrder: {
        closeOrderInfo: 'Close Order Information',
        closeStatus: 'Close Status',
        selectCloseStatus: 'Please select',
        closeOrder: 'Close Order',
        returnOrder: 'Return Order',
        reason: 'Reason',
        reasonPlaceholder: 'Optional, please fill in the reason',
        processed: 'Processed'
      }
    },
    zh: {
      myRepairDispatchManage: {
        queryCondition: '查询条件',
        selectMaintenanceType: '请选择维修类型',
        inputRepairName: '请输入报修人',
        inputRepairTel: '请输入报修电话',
        selectRepairType: '请选择报修类型',
        selectRepairState: '请选择报修状态',
        inputRepairId: '请输入工单编号',
        repairDispatch: '报修已办',
        repairId: '工单编号',
        location: '位置',
        repairType: '报修类型',
        maintenanceType: '维修类型',
        repairPerson: '报修人',
        contact: '联系方式',
        appointmentTime: '预约时间',
        state: '状态',
        operation: '操作',
        detail: '详情',
        scheduledTask: '定时任务处理',
        paidService: '有偿服务',
        freeService: '无偿服务',
        needMaterial: '需要用料',
        noMaterial: '无需用料'
      },
       closeOrder: {
        closeOrderInfo: '结单信息',
        closeStatus: '结单状态',
        selectCloseStatus: '请选择',
        closeOrder: '结单',
        returnOrder: '退单',
        reason: '原因',
        reasonPlaceholder: '选填，请填写原因',
        processed: '已处理'
      }
    }
  }